import { exportPairComparisonResults } from "../exports/exportPairComparison";
import { exportMultipleCriteriaResults } from "../exports/exportMultipleCriteria";
import { exportMultipleChannelResults } from "../exports/exportMultipleChannel";
import { exportManualChoiceResults } from "../exports/exportManualChoice";

export const downloadResultsToExcel = (session, instances) => {
  try {
    if (session.metadata.protocol === "PC") {
      return exportPairComparisonResults(session, instances);
    } else if (session.metadata.protocol === "MS") {
      return exportMultipleCriteriaResults(session, instances);
    } else if (session.metadata.protocol === "MC") {
      return exportMultipleChannelResults(session, instances);
    } else if (session.metadata.protocol === "CM") {
      return exportManualChoiceResults(session, instances);
    }
  } catch (error) {
    console.error("Erreur lors de la création du fichier Excel:", error);
  }
};
